import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PessoaDoencaAtivacaoDto as PessoaDoencaReativacaoDto, PessoaDoencaAtualizacaoDto, PessoaDoencaConsultaDto, PessoaDoencaInativacaoDto, PessoaDoencaInsercaoDto } from '../dtos/doencas/pessoa-doenca-dto';
import { SelectDataSource } from '../libs/ax-select/select-data-source';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class PessoaDoencaService {

  constructor(private http: HttpClient, private url: UrlService) { }

  consultarDoenca(id: number): Observable<PessoaDoencaConsultaDto> {
    return this.http.get<PessoaDoencaConsultaDto>(this.url.url(`pessoas-doencas/${id}`));
  }

  listarHistoricos(pessoaCidId?: number, pessoaId?: number): Observable<PessoaDoencaConsultaDto[]> {
    let params = new HttpParams();
    
    if (pessoaCidId !== undefined) {
      params = params.set('pessoaCidId', pessoaCidId.toString());
    }

    if (pessoaId !== undefined) {
      params = params.set('pessoaId', pessoaId.toString());
    }

    return this.http.get<PessoaDoencaConsultaDto[]>(this.url.url(`pessoas-doencas/historicos`), { params });
  }

  inserirDoenca(dto: PessoaDoencaInsercaoDto): Observable<any> {
    return this.http.post(this.url.url('pessoas-doencas'), dto);
  }

  inativarDoenca(dto: PessoaDoencaInativacaoDto): Observable<any> {
    return this.http.patch(this.url.url('pessoas-doencas/inativacao'), dto);
  }

  reativarDoenca(dto: PessoaDoencaReativacaoDto): Observable<any> {
    return this.http.patch(this.url.url('pessoas-doencas/reativacao'), dto);
  }

  atualizarDoenca(dto: PessoaDoencaAtualizacaoDto): Observable<any> {
    return this.http.patch(this.url.url('pessoas-doencas/atualizacao'), dto);
  }

  excluirDoenca(id: number): Observable<any> {
    return this.http.delete(this.url.url(`pessoas-doencas/${id}`));
  }

  excluirHistorico(id: number): Observable<void> {
    return this.http.delete<void>(this.url.url(`pessoas-doencas/historicos/${id}`));
  }

  listarDoencasAtivas(pessoaId: number): Observable<PessoaDoencaConsultaDto[]> {
    return this.http.get<PessoaDoencaConsultaDto[]>(this.url.url(`pessoas-doencas/pessoas/${pessoaId}/ativas`));
  }

  listarDoencasInativas(pessoaId: number): Observable<PessoaDoencaConsultaDto[]> {
    return this.http.get<PessoaDoencaConsultaDto[]>(this.url.url(`pessoas-doencas/pessoas/${pessoaId}/inativas`));
  }

  listarTodasDoencas(pessoaId: number): Observable<PessoaDoencaConsultaDto[]> {
    return this.http.get<PessoaDoencaConsultaDto[]>(this.url.url(`pessoas-doencas/pessoas/${pessoaId}/todas`));
  }
}
